import {
  deleteNestedValue,
  setNestedValue,
} from "../../../utils/getNestedValue";
import { getParentPathBeforeLastBracket } from "../../../utils/getParentPathBeforeLastBracket";
import { getUpdatedFormDataWithFilledValues } from "./getUpdatedFormDataWithFilledValues";

export const createOrderDataFromContextFormData = (
  formFieldsData: any,
  existingOrderData: Record<string, any>,
) => {
  const onlyFieldsDataValue =
    getUpdatedFormDataWithFilledValues(formFieldsData);

  let data = { ...existingOrderData };
  for (const key in onlyFieldsDataValue) {
    const parentPath = getParentPathBeforeLastBracket(key);

    if (parentPath) {
      data = deleteNestedValue(data, parentPath);
    }
  }
  for (const key in onlyFieldsDataValue) {
    data = setNestedValue(data, key, onlyFieldsDataValue[key]);
  }

  return data;
};
